import { useTranslation } from "react-i18next";
import inflection from "inflection";

import { LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold, Title } from "capitalrx-components-2.0/lib/typography";

import { ThemedButton as BackButton } from "@/common/components/themed";
import { VerticalDivider } from "@/basic/components/VerticalDivider";
import { DrugDetailsResponse } from "@/api/types";

interface DrugDetailsSectionProps {
  readonly drugDetails: DrugDetailsResponse & {
    readonly drug_type: string,
  },
  readonly onBackButtonClicked: () => void,
  readonly isLoading?: boolean,
}


const inflectQuantity = (quantity: number, form: string): string => {
  return inflection.inflect(`${Number(Number(quantity).toFixed(3))} ${form}`, quantity);
};

export const DrugDetailsSection = ({ drugDetails, onBackButtonClicked, isLoading = false }: DrugDetailsSectionProps) => {
  const { t: translate } = useTranslation();
  return (
    <Stack spacing="small" style={{ padding: "1.5rem" }}>
      <LoadingGroup loading={isLoading}>
        <LoadingGroup.Placeholder
          fallback={
            <>
              <Stack spacing="mini">
                <LoadingSkeleton style={{ height: "18px", width: "100px" }} />
                <LoadingSkeleton style={{ height: "36px", width: "150px" }} />
              </Stack>
              <LoadingSkeleton style={{ height: "20px", width: "200px" }} />
            </>
          }
        >
          <Stack spacing="mini">
            <Shelf>
              <BackButton className="back-button" appearance="text" icon="arrow-left" onClick={onBackButtonClicked}>
                {translate("BUTTONS.backButton.back")}
              </BackButton>
              <Shelf.Spacer />
            </Shelf>
            <Title>{drugDetails?.drug_name}</Title>
          </Stack>
          <Shelf spacing="small">
            <Body><Semibold>{drugDetails?.drug_type}</Semibold></Body>
            <VerticalDivider />
            <Body><Semibold>{drugDetails?.dosage}</Semibold></Body>
            <VerticalDivider />
            <Body><Semibold>{inflectQuantity(drugDetails?.quantity, drugDetails?.dosage_form)}</Semibold></Body>
            <VerticalDivider />
            <Body><Semibold>{drugDetails?.days_supply} {translate("FIND_PHARMACIES.drugDetailsForm.days")}</Semibold></Body>
            <Shelf.Spacer />
          </Shelf>
        </LoadingGroup.Placeholder>
      </LoadingGroup>
    </Stack>
  );
};
